module.exports = __webpack_public_path__ + "static/img/coins.507028fb.png";